












































































import { defineComponent, inject } from '@nuxtjs/composition-api';
import {
  SfAccordion,
  SfButton,
  SfHeading,
  SfSidebar,
} from '@storefront-ui/vue';
import { useUiState } from '~/composables';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { getFilterConfig } from '~/modules/catalog/category/config/FiltersConfig';
import ToggleFilters from '~/modules/catalog/category/components/navbar/ToggleFilters.vue';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'CategoryFilters',
  components: {
    ToggleFilters,
    SkeletonLoader,
    CheckboxType: () => import('~/modules/catalog/category/components/filters/renderer/CheckboxType.vue'),
    SwatchColorType: () => import('~/modules/catalog/category/components/filters/renderer/SwatchColorType.vue'),
    RadioType: () => import('~/modules/catalog/category/components/filters/renderer/RadioType.vue'),
    YesNoType: () => import('~/modules/catalog/category/components/filters/renderer/YesNoType.vue'),
    SizeType: () => import('~/modules/catalog/category/components/filters/renderer/SizeType.vue'),
    HeightType: () => import('~/modules/catalog/category/components/filters/renderer/HeightType.vue'),
    SfSidebar,
    SfHeading,
    SfAccordion,
    SfButton,
    SvgImage,
  },
  props: {},
  setup() {
    const {
      selectedFilters, removableFilters, filters, isLoading,
      selectFilter, doRemoveFilter, doApplyFilters, doClearFilters,
    }: any = inject('UseFiltersProvider');
    const {
      isFilterSidebarOpen, toggleFilterSidebar, isDesktopFiltersOpen, toggleDesktopFilters,
    } = useUiState();

    return {
      selectFilter,
      doApplyFilters,
      doRemoveFilter,
      doClearFilters,
      getFilterConfig,
      selectedFilters,
      filters,
      isLoading,
      removableFilters,
      isFilterSidebarOpen,
      toggleFilterSidebar,
      isDesktopFiltersOpen,
      toggleDesktopFilters,
    };
  },
});
